import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import Expense from './Expense';
import {dateFormatter} from 'shared/tools';
import {formatCurrency} from 'shared/core';

class ExpenseRequest extends DomainObject {
  id;
  title;
  description;
  status;
  amount;
  createdAt;
  actionedAt;
  actionedNotes;
  employee;
  actionedByUser;
  expenses = [];

  _relations = {
    employee: Employee,
    actionedByUser: User,
    expenses: [Expense],
    _dates: ['createdAt', 'actionedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      title: observable,
      description: observable,
      status: observable,
      amount: observable,
      createdAt: observable,
      actionedAt: observable,
      actionedNotes: observable,
      employee: observable,
      actionedByUser: observable,
      expenses: observable,
      createdAtView: computed,
      actionedAtView: computed,
      amountView: computed,
      canAction: computed
    });

    this.merge(other);
  }

  get createdAtView() {
    return dateFormatter(this.createdAt);
  }

  get actionedAtView() {
    return dateFormatter(this.actionedAt);
  }

  get amountView() {
    return formatCurrency('CAD', this.amount);
  }

  get canAction() {
    return this.hasLink('approve') && this.hasLink('reject');
  }
}

export default ExpenseRequest;
